import React, { Fragment } from 'react';
import { iconValid } from '../../helpers';
import { Spacer } from '../Spacer/Spacer';
import { Icon, Text } from './styles';
const Loading = props => {
  const {
    theme,
    selectedTheme,
    textColor,
    iconColor,
    column,
    isLoading,
    hasData,
    icon,
    iconSize,
    failIcon,
    noIcon,
    noFailIcon,
    children,
    text,
    failText,
    noText,
    onFail,
    renderOnFail,
    height
  } = props;
  const buildContent = () => {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(Text, {
        $theme: theme,
        $selectedTheme: selectedTheme,
        $column: column,
        $textColor: textColor,
        $height: height
      }, !noIcon && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        $theme: theme,
        $selectedTheme: selectedTheme,
        className: `${iconValid(icon) || 'fa-solid fa-spinner'} fa-spin`,
        $iconSize: iconSize,
        $iconColor: iconColor
      }), /*#__PURE__*/React.createElement(Spacer, {
        across: true
      })), !noText && (text || 'Loading...'));
    }
    if (!isLoading && !hasData) {
      onFail?.();
      if (!renderOnFail) {
        return /*#__PURE__*/React.createElement(Text, {
          $theme: theme,
          $selectedTheme: selectedTheme,
          $column: column,
          $textColor: textColor,
          $height: height
        }, !noFailIcon && /*#__PURE__*/React.createElement(Fragment, null, iconValid(failIcon) ? /*#__PURE__*/React.createElement(Icon, {
          $theme: theme,
          $selectedTheme: selectedTheme,
          className: iconValid(failIcon) || 'fa-solid fa-exclamation-circle',
          $iconSize: iconSize,
          $iconColor: iconColor
        }) : failIcon || /*#__PURE__*/React.createElement(Icon, {
          $theme: theme,
          $selectedTheme: selectedTheme,
          className: "fa-solid fa-exclamation-circle",
          $iconSize: iconSize,
          $iconColor: iconColor
        }), /*#__PURE__*/React.createElement(Spacer, {
          across: true
        })), !noText && (failText || 'Load failed.'));
      }
    }
    return children;
  };
  return /*#__PURE__*/React.createElement(Fragment, null, buildContent());
};
export { Loading };